export default "__VITE_ASSET__B$eVZHYu__"